import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

const pricingCalculatorService = {
  estimate: (payload) => apiClient.post(ENDPOINTS.PRICING_CALC.ESTIMATE, payload),

  listProducts: (sellerAccountId) =>
    apiClient.get(ENDPOINTS.PRICING_CALC.PRODUCTS, { params: { sellerAccountId } }),

  getRates: (sellerAccountId, sku) =>
    apiClient.get(ENDPOINTS.PRICING_CALC.RATES, {
      params: { sellerAccountId, ...(sku ? { sku } : {}) },
    }),

  /**
   * Live SP-API call: returns Amazon's actual referral / closing / FBA fees for a specific
   * SKU at a hypothetical price. Falls back gracefully (response.source === "unavailable")
   * when the SKU has no ASIN or SP-API can't fulfil the request — UI then keeps using the
   * historical-average fees from estimate().
   */
  getSpApiFees: (sellerAccountId, sku, listingPrice, isAmazonFulfilled = false) =>
    apiClient.get(ENDPOINTS.PRICING_CALC.SP_API_FEES, {
      params: { sellerAccountId, sku, listingPrice, isAmazonFulfilled },
    }),
};

export default pricingCalculatorService;
